export default async (request) => {
  const [ err, response ] = await request.get('/registrations/invalid-domains')

  return [ err, response ]
}
